const CustomComponentCell = (props) => {
  const { field } = props;
  const { Component } = field;

  return <Component {...props} />;
};

export default CustomComponentCell;
